  
<template>
		<div>
				<AppBar></AppBar>
				<div class="page-content header-clear-medium">
						<div class="card card-style">
								<div class="content mt-4 mb-0">
										<h1 class="text-center font-900 font-40 mb-0">Login</h1>
										<p class="bottom-0 text-center color-highlight font-11">Log in to your account</p>
                    <div class="alert alert-warning" v-if="error">
                      {{error}}
                    </div>
                    <div class="alert alert-success" v-else-if="message.length > 0">
                      {{message}}
                    </div>
										<div class="input-style has-icon input-style-1 input-required pb-1">
<!--												<i class="input-icon fa fa-user color-theme"></i>-->
                      <span>Phone number</span>
                      <em>(required)</em>
                      <input v-model="username" placeholder="Phone number" type="number">
                    </div>
                  <div class="input-style has-icon input-style-1 input-required pb-1">
                    <!--												<i class="input-icon fa fa-lock color-theme"></i>-->
                    <span>Password</span>
                    <em>(required)</em>
                    <input v-model="password" placeholder="Password" type="password">
                  </div>
                  <div class="container">
                    <div class="col-md-12 text-center ">
                      <button v-if="!loading" class="btn btn-3d btn-m  mb-3 rounded-5 text-uppercase font-900 shadow-s border-red2-dark bg-red2-light mb-3"
                              @click="processLogin">
                        Login
                      </button>
                      <mushonga v-else></mushonga>
                    </div>
                  </div>
                  <div class="divider"></div>
<!--                  <div class="d-flex">-->
<!--                    <div class="w-50 font-11 pb-2 color-theme opacity-60 pb-3 text-left">-->
<!--                      <router-link class="color-theme" to="/password">Request Password</router-link>-->
<!--                    </div>-->
<!--                    <div class="w-50 font-11 pb-2 color-theme opacity-60 pb-3 text-right">-->
<!--                      <router-link class="color-theme" to="/password">Forgot Credentials</router-link>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
						</div>
				</div>
		</div>
</template>

<script>
import axios from "axios"
import AppBar from "../../components/AppBar";
import global from "@/mixins/global";
import {mapMutations} from "vuex"
export default {
      beforeMount() {
        this.resetMessages()
        localStorage.clear()
      },
      mixins: [global],
        name: "Login",
        components: {AppBar},
        data(){
            return{
                username: "",
                password: ""
            }
        },
        methods: {
          ...mapMutations(["updateUser"]),
            processLogin(){
              this.loading = true
              this.resetMessages()
              axios.post(this.base_url+"login", {
                phone_number: this.username,
                password: this.password
              }, this.requestHeader()).then(response=>{
                this.response = response

                if(response.data.subscribe === 0){
                   this.message = "Account Not Subscribed"
                   this.loading = false 
                   return 0
                }

                if (response.status === 200) {
                  this.message = "Login successful"
                  localStorage.setItem("token", response.data.token)
                  localStorage.setItem("user", JSON.stringify(response.data.user))
                  this.updateUser(response.data.user)
                }
                
                console.log(response.data.subscribe === 0)

                if (parseInt(response.data.user.admin) === 1) {
                  setTimeout(() => {
                    this.$router.push("/admin")
                  }, 2000)
                } else {
                  setTimeout(() => {
                    this.$router.push("/home")
                  }, 2000)
                }
              }).catch(error =>{
                this.loading = false
                this.error = error
                if(error.response.status === 401){
                  this.error = "Invalid username or password. Check and try again"
                }
              })
            },
          updateFormError(error){
              this.error = error
          }
        }
    }
</script>
<style scoped>
.btn-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
 
}
input{
  border-radius: 6px;
}
.btn-edit{
  font-size: 2rem;
}

</style>